import {ErrorInfo} from 'react'
import * as Sentry from '@sentry/react'
import {createBrowserHistory} from 'history'
import {UserInfo} from 'interfaces'

const history = createBrowserHistory()

const init = () => {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV,
    integrations: [
      Sentry.reactRouterV5BrowserTracingIntegration({history}),
      Sentry.replayIntegration({
        maskAllText: false,
      }),

      Sentry.browserProfilingIntegration(),
      Sentry.browserTracingIntegration(),
    ],
    profilesSampleRate: 1.0, // Capture 100% of the profiles
    replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    release: process.env.REACT_APP_SENTRY_RELEASE,
    sendDefaultPii: true,
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
  })
}

const SetUserLogScope = (user: Partial<UserInfo>) => {
  Sentry.getCurrentScope()?.setUser({
    id: user.emailId,
  })
}

const LogUncaughtError = (error: Error, errorInfo: ErrorInfo) => {
  Sentry.withScope(scope => {
    scope.setExtra('Uncaught Error', errorInfo)
    Sentry.captureException(error)
  })
}

const LogError = (error: Error) => {
  Sentry.withScope(scope => {
    scope.setExtra('error', error)
    Sentry.captureException(error)
  })
}

export default {init, SetUserLogScope, LogError, LogUncaughtError}
